// Mirror of weapon-state-roles.json (the canonical copy PHP reads) for the browser bundles, which
// cannot import JSON. tools/test/weapon-state-roles-contract.mjs fails if the two drift.
import { selectInventoryMeshSet } from './mesh-presentation.js';

export const WEAPON_STATE_ROLES = Object.freeze({
  '40DDC931-6479-B773-293E-CE570E99B975': Object.freeze({ held: 'open', stowed: 'closed' }),
  '742A06CA-5870-FA3B-603A-AEE94F5102F5': Object.freeze({ held: 'relaxed', stowed: 'coiled' }),
  'D7BB53E2-0544-9AC9-7DD3-4FA47A12C80C': Object.freeze({ held: 'loaded', stowed: 'bundled' }),
  '81AF4123-10E6-8656-F9CA-DCE1AC3DC7E3': Object.freeze({ held: 'coiled_held', stowed: 'coiled_held' }),
  'E6CCEF87-419A-57CF-DC12-73324DB86CD1': Object.freeze({ held: 'cocked', stowed: 'cocked' }),
  'D5906717-7237-CA1D-B089-18CF323A04DB': Object.freeze({ held: 'pose_1', stowed: 'pose_1' }),
});

/** The state a weapon of this classification shows for a role ('held' | 'stowed'), or null. */
export function weaponStateForRole(classificationId, role) {
  const roles = WEAPON_STATE_ROLES[String(classificationId ?? '').toUpperCase()];
  return roles?.[role] ?? null;
}

/**
 * Resolve an equipped weapon's mesh set, then prefer `state` INSIDE the variant already chosen.
 * A shared classification (Flails) must never swap an ordinary flail for a different variant that
 * happens to ship the state, so the state is only taken when the resolved variant has it.
 */
export function selectWeaponMeshSetInState(itemArr, options, state) {
  const base = selectInventoryMeshSet(itemArr, options);
  if (!base || !state) return base;
  const inState = selectInventoryMeshSet(itemArr, { ...options, variant: base.variant, state });
  return inState?.meshes?.length && inState.meshes.every(mesh => mesh.state === state) ? inState : base;
}
